// Prepared clips preserve the whole camera movement at normal playback speed.
// Keep original source/reverse semantics for older or still-processing records.
export const MAX_PREPARED_TRANSITION_SECONDS = 1.8;

export function resolveTransitionPlayback(transition, reverse = false) {
  const source = transition?.transition_media_url || null;
  const duration = Number(transition?.playback_duration);
  const ready = transition?.playback_status === "ready"
    && transition?.playback_source_url === source
    && !!source && Number.isFinite(duration) && duration > 0 && duration <= MAX_PREPARED_TRANSITION_SECONDS;
  const forward = ready ? transition.transition_playback_url : null;
  const backwards = ready ? transition.transition_reverse_playback_url : null;
  if (reverse && backwards) {
    return { url: backwards, reverse: false, prepared: true, duration };
  }
  return {
    url: forward || source,
    reverse: !!reverse,
    prepared: !!forward,
    duration: forward ? duration : null,
  };
}
